/// Port of mobile/lib/core/ui/snackbar/controller/snackbar_controller.dart.
/// Global toast queue — single visible snack, survives route changes.

import { create } from 'zustand';

export type SnackKind = 'success' | 'error' | 'info';

export interface AppSnack {
  id: number;
  message: string;
  kind: SnackKind;
}

interface SnackbarState {
  snack: AppSnack | null;
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  show: (message: string, kind?: SnackKind) => void;
  clear: () => void;
}

const displayMs = 3200;
let nextId = 0;
let dismissTimer: ReturnType<typeof setTimeout> | null = null;

export const useSnackbarStore = create<SnackbarState>((set) => ({
  snack: null,

  success: (message) => useSnackbarStore.getState().show(message, 'success'),
  error: (message) => useSnackbarStore.getState().show(message, 'error'),
  info: (message) => useSnackbarStore.getState().show(message, 'info'),

  show: (message, kind = 'success') => {
    const trimmed = message.trim();
    if (!trimmed) return;

    if (dismissTimer !== null) {
      clearTimeout(dismissTimer);
      dismissTimer = null;
    }

    set({ snack: { id: nextId++, message: trimmed, kind } });
    dismissTimer = setTimeout(() => {
      useSnackbarStore.getState().clear();
    }, displayMs);
  },

  clear: () => {
    if (dismissTimer !== null) {
      clearTimeout(dismissTimer);
      dismissTimer = null;
    }
    set({ snack: null });
  },
}));
